import { createTypes } from 'reduxsauce';

export default createTypes(
  `
  LANGUAGE_CHANGE
  LOGOUT
`,
  {},
);
